import { FETCH_VIRAL_NOW_DATA, FETCH_PREDICTED_VIRALITY_DATA, FETCH_ADMIN_TH_VALUE } from "../actions/viralityDataAction";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const viralityDataReducer = (
    state = {
        viralNowData: [],
        viralNowDataFetching: false,
        viralNowDataFetched: false,
        predictedViralityData: [],
        predictedViralityDataFetching: false,
        predictedViralityDataFetched: false,
        viralNowHasMore: true,
        predictedViralityHasMore: true,
        viralNowOffset: 0,
        predictedViralityOffset: 0,
        viralNowTotal: 0,
        predictedViralityTotal: 0,
        viralNowPostsFetched: 0,
        predictedViralityPostsFetched: 0,
        auto_push_in_operation: false,
        adminViralityThresholdValue: "",
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_VIRAL_NOW_DATA):
            if (!state.auto_push_in_operation) {
                state = {
                    ...state,
                    viralNowDataFetching: true,
                    viralNowData: [],
                };
            } else {
                state = {
                    ...state,
                    viralNowDataFetching: true,
                };
            }

            break;
        case isRejected(FETCH_VIRAL_NOW_DATA):
            state = {
                ...state,
                viralNowDataFetching: false,
            };
            break;
        case isFulfilled(FETCH_VIRAL_NOW_DATA):
            state = {
                ...state,
                viralNowDataFetching: false,
                viralityDataFetched: true,
                viralNowData: action.payload.hits.hits,
                viralNowTotal: action.payload.hits.total,
                viralNowOffset: action.payload.offset,
                viralNowHasMore: action.payload.hits.hits.length < action.payload.hits.total,
                viralNowPostsFetched: action.payload.hits.hits.length,
            };
            break;
        case isPending(FETCH_PREDICTED_VIRALITY_DATA):
            if (!state.auto_push_in_operation) {
                state = {
                    ...state,
                    predictedViralityDataFetching: true,
                    predictedViralityData: [],
                };
            } else {
                state = {
                    ...state,
                    predictedViralityDataFetching: true,
                };
            }

            break;
        case isRejected(FETCH_PREDICTED_VIRALITY_DATA):
            state = {
                ...state,
                predictedViralityDataFetching: false,
            };
            break;
        case isFulfilled(FETCH_PREDICTED_VIRALITY_DATA):
            state = {
                ...state,
                predictedViralityDataFetching: false,
                predictedViralityDataFetched: true,
                predictedViralityData: action.payload.hits.hits,
                predictedViralityTotal: action.payload.hits.total,
                predictedViralityOffset: action.payload.offset,
                predictedViralityHasMore: action.payload.hits.hits.length < action.payload.hits.total,
                predictedViralityPostsFetched: action.payload.hits.hits.length,
            };
            break;
        case isPending(FETCH_ADMIN_TH_VALUE):
            state = { ...state, adminViralityThresholdValue: "" };
            break;
        case isRejected(FETCH_ADMIN_TH_VALUE):
            state = { ...state, adminViralityThresholdValue: "" };
            break;
        case isFulfilled(FETCH_ADMIN_TH_VALUE):
            console.log(action.payload);
            state = { ...state, adminViralityThresholdValue: action.payload.company.virality_impact_threshold };
            break;

        default:
            return state;
    }
    return state;
};

export default viralityDataReducer;
